import React from "react";
import { TouchableOpacity, StyleSheet, View } from "react-native";

import { hasUnreadComments, navigate } from "../../../../helpers/utils";

import CommentUnreadIcon from "../../common/icons/reports/CommentUnreadIcon";
import AddCommentIcon from "../../common/icons/reports/AddCommentIcon";
import appPages from "../../../../appPages";

export default function ReportCommentIcon({ controller, report, styles = {} }) {
  const showUnreadIcon = hasUnreadComments(controller, report);

  // ------------------------------------- METHODS -------------------------------------
  const viewReport = () => {
    navigate(controller, appPages.reportComments, "changePage", {
      reportId: report.id,
    });
  };

  return (
    <View style={[s.root, styles]}>
      <TouchableOpacity style={s.container} onPress={viewReport}>
        {showUnreadIcon ? <CommentUnreadIcon /> : <AddCommentIcon />}
      </TouchableOpacity>
    </View>
  );
}

const s = StyleSheet.create({
  root: {
    position: "relative",
    zIndex: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 20,
    height: 20,
  },
  container: {
    width: 20,
    height: 20,
  },
});
